import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, ArrowRight, House } from "lucide-react";
function ListingsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] w-full animate-pulse rounded-xl bg-muted" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-destructive">Error loading listings. Please try again later.</div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="flex min-h-[300px] flex-col items-center justify-center rounded-xl border border-dashed bg-muted/30 p-8 text-center">
        <House className="mb-4 size-10 text-muted-foreground/50" />
        <h3 className="text-lg font-medium">No listings found</h3>
        <p className="text-muted-foreground">Check back soon for new properties in Abilene.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} className="group block h-full" data-index={i}>
          <Card className="h-full overflow-hidden border-border bg-card transition-all duration-300 hover:shadow-lg hover:shadow-primary/5">
            <div className="relative aspect-[4/3] overflow-hidden bg-muted">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                  <House className="size-12 opacity-20" />
                </div>}
              
              {}
              <div className="absolute left-4 top-4 flex flex-wrap gap-2">
                {post.categories?.slice(0, 2).map(cat => <Badge key={cat.id} variant="secondary" className="bg-background/90 text-foreground backdrop-blur-sm shadow-sm">
                    {cat.name}
                  </Badge>)}
                {!post.categories?.length && <Badge variant="secondary" className="bg-background/90 text-foreground backdrop-blur-sm shadow-sm">
                    Available
                  </Badge>}
              </div>
            </div>

            <CardContent className="flex flex-col gap-3 p-6">
              <h3 className="line-clamp-1 text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
                {post.title}
              </h3>
              
              <div className="flex items-center gap-2 text-muted-foreground">
                <MapPin className="size-4 shrink-0 text-primary" />
                <span className="text-sm font-medium">Abilene, TX</span>
              </div>

              {post.excerpt && <div className="line-clamp-2 text-sm text-muted-foreground/80" dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />}
            </CardContent>
          </Card>
        </Link>)}
    </div>;
}
export default function FeaturedAbileneSpaces() {
  const wp_query_params = {
    post_type: "post",
    per_page: 6,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}